<template>
<b-container fluid class="container">

<!-- Excepción -->
  <div v-if="this.noDatos == true" class="row justify-content-center">

              <div class="row justify-content-center ">
                <div class="col-sm-9 text-center mb-2">
                  <p>Esta unidad no esta disponible para calcular una suscripción.</p>
                  <p>Puedes contactarnos a <span style="color: #172546;"> <b>ClikAuto</b></span> <span style="color: #51AED3;"> <b>Mobility</b></span> 800-022-5425</p>
                  <div>
                     <b-button @click.prevent="regresar()" class="button_bk">REGRESAR</b-button>
                  </div>

                </div>
              </div>
  </div>

  <!-- Botones Largas --> 
  <div v-if="this.noDatos == false" class="row justify-content-center">
    <div class="row justify-content-center">
            <div class="col-sm-9 text-center">
              <h1>Selecciona el período que necesitas.</h1>
              <p class="detalles">Elige una de las opciones.</p>
            </div>
    </div>

    <div class="col-sm-4 text-center">
    <b-col>
          <b-form-group id="input-group-11" label-for="input-11">
              <h6 class="mb-4">Lugar de entrega del auto</h6>
              <p style="font-size: 18px; color: #51555C; font-weight: 400;font-family: 'Open Sans';font-style: normal;">Domicilio</p>
          </b-form-group>
      </b-col>
    </div>
    <div class="col-sm-4">
    <b-col>
          <b-form-group id="input-group-11" label-for="input-11">
              <h6>Selecciona el estado de emplacamiento</h6>
                  <b-form-select id="input-11" v-model="estado" :options="estados" class="mb-2 select"></b-form-select>
          </b-form-group>
      </b-col>
    </div>

    <div class="col-sm-12 text-center">
      <p style="font-family: 'Open Sans'; font-size: 11px; color: #51555C;">** Los servicios se realizarán en las entidades de emplacamiento y al término del plazo se devuelve en distribuidor.</p>
        <!-- <h6 class="mt-4 mb-4 h6TI" >Selecciona la mensualidad</h6> -->
        <h6 class="mt-4 mb-4 h6TI" >Suscripción mensual</h6>
      <b-row 
        cols="1" cols-sm="1" cols-md="2" cols-lg="2">
        <b-col> <b-button @click.prevent="mesesDos()" class="button_s"><p style="font-family: 'Open Sans'; font-style: normal; font-weight: 400; font-size: 20px;"> <b>12 Meses</b> <br> Suscripción inicial <b>${{ this.formatPrice(this.suscripcionInicial) }}</b> <br> Suscripción mensual <b>${{this.formatPrice(calcula12())}}</b></p></b-button></b-col>
        <b-col> <b-button @click.prevent="mesesOcho()" class="button_s"><p style="font-family: 'Open Sans'; font-style: normal; font-weight: 400; font-size: 20px;"> <b>18 Meses</b> <br> Suscripción inicial <b>${{ this.formatPrice(this.suscripcionInicial18) }}</b> <br> Suscripción mensual  <b >${{this.formatPrice(calcula18())}}</b></p></b-button></b-col>
        <b-col> <b-button @click.prevent="mesesCuatro()" class="button_s"><p style="font-family: 'Open Sans'; font-style: normal; font-weight: 400; font-size: 20px;"> <b>24 Meses</b> <br>  Suscripción inicial <b>${{ this.formatPrice(this.suscripcionInicial24) }}</b> <br> Suscripción mensual <b class="ml-1">${{this.formatPrice(calcula24())}}</b></p></b-button></b-col>
        <b-col> <b-button @click.prevent="mesesSeis()" class="button_s"><p style="font-family: 'Open Sans'; font-style: normal; font-weight: 400; font-size: 20px;">  <b>36 Meses</b> <br>  Suscripción inicial <b>${{ this.formatPrice(this.suscripcionInicial36) }}</b> <br> Suscripción mensual <b class="ml-1">${{this.formatPrice(calcula36())}}</b></p></b-button></b-col>
        <b-col> <b-button @click.prevent="mesesCuatroOcho()" class="button_s"><p style="font-family: 'Open Sans'; font-style: normal; font-weight: 400; font-size: 20px;"> <b>48 Meses</b> <br>  Suscripción inicial <b>${{ this.formatPrice(this.suscripcionInicial48) }}</b> <br> Suscripción mensual <b class="ml-1">${{this.formatPrice(calcula48())}}</b></p></b-button></b-col>
      </b-row>
    </div>

    <div class="col-sm-12 text-center">
      <p class="personaM"> Si eres persona moral, llena el formulario en el siguiente enlace.</p>
      <b-row class="justify-content-md-center">
        <b-col><b-button @click.prevent="encuesta()" class="button_s1"><b>Soy persona moral</b></b-button></b-col>
      </b-row>
    </div>

  </div>
</b-container>
</template>

<script>

export default {
  name: 'Largas',

  data() {
    return {
      estado: 'DF',
      entrega: 'Domicilio',
      altaPlacas: 0,

      //Largas
      noDatos: false,
      
      movilVersion: '',
      fullmodel: '',
      precioLista: '',
      precioSeguro: '',
      puntos: '',

      //fix:22.90,
      //fix: 25.90,
      fix: 23.50,

      //gastos de investigación 1392 (precio con iva) / 1.16 = 116
      ginvestigacion: 0,

      //accesories: 1219,
      //accesories: '',
      
      //Valores GPS
      accesories12: 5822.04,
      accesories18: 8246.44,
      accesories24: 8246.44,
      accesories36: 10670.84,
      accesories48: 13095.24,
      //porcentaje: 0.15,
      porcentaje: 0,
      //plates: 43.92,
      plates: 131.75,

      //12m
      residual1: '',
      mc: '',
      kms12: 20000,

      //18m
      residual2: '',
      mc18: '',
      kms18: 30000,

      //24m
      residual3: '',
      mc24: '',
      kms24: 40000,

      //36m
      residual4: '',
      mc36: '',
      kms36: 60000,

      //48m
      residual5: '',
      mc48: '',
      kms48: 80000,

      //Tipos Suscripciones
      suscripcionInicial: '',
      suscripcionInicial18: '',
      suscripcionInicial24: '',
      suscripcionInicial36: '',
      suscripcionInicial48: '',

      contents: null,
      autos: [],
      photos: [],
      vin: this.$route.query.vin,
      timeout: null,
      estados: [
        { value: 'DF', text: 'CDMX / Edo. de Mex' },
        { value: 'QT', text: 'Querétaro' },
        { value: 'MN', text: 'Michoacán' },
        { value: 'GT', text: 'Guanajuato' }
      ],
      entregas: [
        { value: 'Domicilio', text: 'Domicilio' },
        { value: 'Trabajo', text: 'Trabajo' },
        { value: 'Distribuidor', text: 'Distribuidor' }
      ],
      };
  },

  methods: {

    encuesta(){
      window.open("https://www.clikautomobility.com/landing-suscripcion-persona-moral");
    },
    cargarInfoVehiculo(){
          axios.get("https://autocomcube.mx/ab/api/newstock", {
          headers: {
            Authorization: "Bearer " + sessionStorage.getItem("tokenStock"),
            'Content-Type': 'application/json',},
              params: {vin: this.vin,},
              }).then((response) => {
                  sessionStorage.setItem("TipoSuscripcion", 2);
                  sessionStorage.setItem("status", 'new');
                  sessionStorage.setItem("kms", 0);
                  this.precioaa = response.data.newstock[0].newsuscriptionDetails.precioAa;
                  this.precioLista = response.data.newstock[0].webPrice;
                  this.brand = response.data.newstock[0].brandDescription;
                  this.model = response.data.newstock[0].modelDescription;
                  this.fullmodel = this.brand + ' ' + this.model;
                  this.dealerShip = response.data.newstock[0].dealerShip;
                  this.year = response.data.newstock[0].modelYear
                  sessionStorage.setItem("dealerShip", this.dealerShip);
                  //  console.log('Modelo full -->',this.fullmodel);
                  this.obtenerModelo();
              }).catch(error => {
            this.noDatos = true;
            console.log('No se pudo obtener info en Cube');
            console.log(error);
          });
    },

    obtenerModelo(){
      //console.log('vin de entrada-->',this.vin);
    axios.get("https://suscripciones.autocom.mx/api/autosVin/"+this.vin )
      .then((response) => {
        this.movilVersion = response.data[0].model_description;
        //console.log('AUto -->',this.movilVersion);
        this.infoAutos();
        }).catch(error => {
          this.noDatos = true;
          console.log('No se pudo obtener el Modelo en Cube');
          console.log(error);
        });
    },
    infoAutos(){
      let info = {
      model: this.movilVersion,
      year: this.year};

    //console.log('Info -->',info);
    axios.post("https://suscripciones.autocom.mx/api/autos", info)
      .then((response) => {
        this.contents = response;
              this.precioSeguro = this.contents.data[0].insurance;
              //this.precioLista = this.contents.data[0].list_price;
              this.puntos =  this.contents.data[0].points;
              this.variables12();
              this.variables18();
              this.variables24();
              this.variables36();
              this.variables48();
        }).catch(error => {
          this.noDatos = true;
          console.log('No se pudo obtener Seguro / Puntos Versión -> ',this.movilVersion);
          console.log(error);
        });
    },

    variables12(){
      let info12 = {
      // description: this.fullmodel,
      // kms: this.kms12,
      // months: 12
      kms: 20000,
      months: 12
    };

    axios.post("https://suscripciones.autocom.mx/api/valoresUnicos", info12)
    .then((response) => {
        this.contents = response;
              this.residual1 = this.contents.data[0].pondera;
              this.mc = this.contents.data[0].mantto;
              // console.log('RV -->',this.residual1 + 'MC -->',this.mc);
        }).catch(error => {
          this.noDatos = true;
          console.log('No se pudo obtener RV / MC Modelo -> ',this.fullmodel);
          console.log(error);
        });
    },

    variables18(){
      let info18 = {
      // description: this.fullmodel,
      // kms: this.kms18,
      // months: 18
      kms: 30000,
      months: 18
    };

    axios.post("https://suscripciones.autocom.mx/api/valoresUnicos", info18)
    .then((response) => {
        this.contents = response;
              this.residual2 = this.contents.data[0].pondera;
              this.mc18 = this.contents.data[0].mantto;
        }).catch(error => {
          console.log(error);
        });
    },

    variables24(){
      let info24 = {
      // description: this.fullmodel,
      // kms: this.kms24,
      // months: 24
      kms: 40000,
      months: 24
    };

    axios.post("https://suscripciones.autocom.mx/api/valoresUnicos", info24)
    .then((response) => {
        this.contents = response;
              this.residual3 = this.contents.data[0].pondera;
              this.mc24 = this.contents.data[0].mantto;
        }).catch(error => {
          console.log(error);
        });
    },

    variables36(){
      let info36 = {
      // description: this.fullmodel,
      // kms: this.kms36,
      // months: 36
      kms: 60000,
      months: 36
    };

    axios.post("https://suscripciones.autocom.mx/api/valoresUnicos", info36)
    .then((response) => {
        this.contents = response;
              this.residual4 = this.contents.data[0].pondera;
              this.mc36 = this.contents.data[0].mantto;
              //console.log('RV -->',this.residual4 + 'MC -->',this.mc36);
        }).catch(error => {
          console.log(error);
        });
    },

    variables48(){
      let info48 = {
      // description: this.fullmodel,
      // kms: this.kms36,
      // months: 36
      kms: 80000,
      months: 48
    };

    axios.post("https://suscripciones.autocom.mx/api/valoresUnicos", info48)
    .then((response) => {
        this.contents = response;
              this.residual5 = this.contents.data[0].pondera;
              this.mc48 = this.contents.data[0].mantto;
              //console.log('RV -->',this.residual4 + 'MC -->',this.mc36);
        }).catch(error => {
          console.log(error);
        });
    },

    valorPlacas(){
      //console.log('valor placas --->' ,this.estado);
      let info = {
      estado: this.estado};

    axios.post("https://suscripciones.autocom.mx/api/costoPlacas", info)
      .then((response) => {

        this.altaPlacas = parseInt(Number(response.data[0].costo));
        //console.log('Alta Placas ->',this.altaPlacas);

        }).catch(error => {
          this.noDatos = true;
          console.log('No se pudo obtener Valor de Emplacamiento -> ',this.estado);
          console.log(error);
        });
    },

    calcula12(){
    console.log('Precio Lista --->',this.precioLista);
    console.log('Precio AA --->',this.precioaa);
      this.precioList = (this.precioLista/1.16);
     //console.log('Precio lista--->',this.precioList);
      this.preciosEspecial = (this.precioaa/1.16);
      //console.log('Precio Especial 12 --->',this.preciosEspecial);
      this.rentaExtra = (this.preciosEspecial * 0.1);
      this.comisionApert = (this.preciosEspecial * 0.01);
      //console.log('Renta Extra Ordinaria 12 -->',this.rentaExtra);
      //console.log('Comisión Apertura 12 -->',this.comisionApert);
      //console.log('Descuento -->',(this.formatPriceCostos((1-(this.preciosEspecial/this.precioList))*100)));
      this.valorResidual = parseFloat(this.residual1)+parseFloat(this.puntos);
     //Provicional----this.valorResidual = 65.00;
     //console.log('Valor Residual %-->',this.valorResidual);
      this.valorResidualT = ((this.precioList * this.valorResidual)/100);
      //console.log('Valor Residual $ -->',this.valorResidualT);
      this.restaExtra = (this.preciosEspecial - this.rentaExtra);
      //console.log('Valor resta renta extraordinaria ---> ',this.restaExtra);
     this.calcula = (this.restaExtra-(this.valorResidualT/((1+(this.fix/100)/12)**12)));
      //console.log('Calcular -->',this.calcula);
      //console.log('----------------------------');
    this.calcula2 = ((1-(1+(this.fix/100)/12)**-12));
      //console.log('Calculo 2 -->',this.calcula2);
     this.otro = ((this.fix/100)/12);
      //console.log('otro -->',this.otro);
     this.otro2 = ((1+(this.fix/100)/12));
      //console.log('otro 2-->',this.otro2);
    this.claculo3 = ((this.calcula2/this.otro)*this.otro2);
    this.claculo3 = (this.calcula2/this.otro);

      //console.log('Calculo 3--->',this.claculo3);
      //console.log('----------------------------');
     this.total = this.calcula/this.claculo3;
      //console.log('Financial cost vehicle -->',this.total);
      //console.log('----------------------------');
    //this.accesories = 6947.24;
     this.accesorios = this.accesories12/this.claculo3;
      //console.log('Costo Accesorios-->',this.accesorios);
      //console.log('----------------------------');
     this.financia = (this.total+this.accesorios);
    //console.log('Monthly Financial Lease-->',this.financia);
    //console.log('----------------------------');
    //console.log('Seguro -->',this.precioSeguro);
    //this.insurance = (((this.precioSeguro/1.16)/12)*(1-this.porcentaje));
    this.insurance = (((this.precioSeguro/1.16))*(1-this.porcentaje));
    this.insuranceFinal = (this.insurance/this.claculo3);
    console.log('Insurance -->',this.insuranceFinal);
    //  console.log('----------------------------');
    //  console.log('Estados -->',this.estado);
    //console.log('Valor Estado--->',this.valorEdo);
    //this.mantenimiento = (((this.mc/100)*20000)/12);
    this.mantenimiento = ((this.mc/100)*20000);
    //  console.log('Mantenimiento --->',this.mantenimiento);
     //this.telematics = 203.49;
     this.telematics = 0;
    //  console.log('plates --->',this.plates);
    //  console.log('Telematics --->',this.telematics);
    
    this.calcularEdos();

    this.valorPlacas();

    //Plates
    //this.totalPlates = ((this.plates*2)*12);
    this.totalPlates = ((this.plates*12)+2400);

    // this.totalServicios = (this.insurance + this.valorEdo + this.mantenimiento + this.telematics + this.plates);
    this.totalServicios = (this.totalPlates + this.altaPlacas + (this.valorEdo*2) + this.mantenimiento + this.ginvestigacion);
    //  console.log('Total Plates -->', this.totalPlates);
    //  console.log('Total Alta Placas -->', this.altaPlacas);
    //  console.log('Total Valor Edo -->',this.valorEdo);
    //  console.log('Total Mantenimiento -->',this.mantenimiento);
    //  console.log('Total Gastos de Investigación -->',this.ginvestigacion);

    //  console.log('Total Services -->',this.totalServicios);
    //  console.log('------------------------------------');
    this.finalCostService = (this.totalServicios / this.claculo3 );


    this.monthlyServiceLease = (this.insuranceFinal + this.finalCostService);

    // console.log('Monthly financial lease -->',this.financia);
    // console.log('Monthly service lease -->',this.monthlyServiceLease);

    //this.resultado12 = (((this.financia + this.totalServicios)*1.16)+this.ginvestigacion);
    this.resultado12 = (((this.financia + this.monthlyServiceLease)*1.16));

    // console.log('Total a Pagar --->',this.resultado12);

    this.suscripcionInicial = ((this.rentaExtra*1.16) + (this.comisionApert*1.16) + this.resultado12 );


      return this.resultado12;
    },

    calcula18(){
      this.precioList = (this.precioLista/1.16);
      this.preciosEspecial = (this.precioaa/1.16);
      this.rentaExtra = (this.preciosEspecial * 0.1);
      this.comisionApert = (this.preciosEspecial * 0.01);
      this.valorResidual = parseFloat(this.residual2)+parseFloat(this.puntos);
      this.valorResidualT = ((this.precioList * this.valorResidual)/100);
      this.restaExtra = (this.preciosEspecial - this.rentaExtra);
      this.calcula = (this.restaExtra-(this.valorResidualT/((1+(this.fix/100)/12)**18)));
      this.calcula2 = ((1-(1+(this.fix/100)/12)**-18));
      this.calcula22 = ((1-(1+(this.fix/100)/12)**-12));
      this.otro = ((this.fix/100)/12);
      this.otro2 = ((1+(this.fix/100)/12));
      //this.claculo3 = ((this.calcula2/this.otro)*this.otro2); 
      this.claculo3 = (this.calcula2/this.otro); 
      this.claculo33 = (this.calcula22/this.otro);
      this.total = this.calcula/this.claculo3;
      //this.accesories = 9371.64;
      this.accesorios = this.accesories18/this.claculo3;
      this.financia = (this.total+this.accesorios);
      //this.insurance = (((this.precioSeguro/1.16)/12)*(1-this.porcentaje));

      this.insurance = (((this.precioSeguro/1.16))*(1-this.porcentaje));

      this.insuranceFinal = (this.insurance/this.claculo33);
    
    // this.mantenimiento = (((this.mc18/100)*this.kms18)/18);
    //this.mantenimiento = (((this.mc18/100)*30000)/18);
    this.mantenimiento = ((this.mc18/100)*30000);
    //  this.telematics = 203.49;
    this.telematics = 0;

    this.calcularEdos();

    this.valorPlacas();

    //Plates
    //this.totalPlates = ((this.plates*2)*18);
    this.totalPlates = ((this.plates*18)+2400);

    //Operación Tenencia 
    this.costoTenencia = ((18+12)/12);
    this.tenencia = this.valorEdo*this.costoTenencia;
    // console.log('División 18 / 12',this.costoTenencia);
    //console.log('Valor del tenencia -->',this.tenencia);

    //this.totalServicios = (this.insurance + this.valorEdo + this.mantenimiento + this.telematics + this.plates);
    this.totalServicios = (this.totalPlates + this.altaPlacas + this.tenencia + this.mantenimiento + this.ginvestigacion);
      // console.log('Total Plates -->', this.totalPlates);
      // console.log('Total Alta Placas -->', this.altaPlacas);
      // console.log('Total Valor Edo -->',this.tenencia);
      // console.log('Total Mantenimiento -->',this.mantenimiento);
      // console.log('Total Gastos de Investigación -->',this.ginvestigacion);

      // console.log('Total Services -->',this.totalServicios);
      // console.log('------------------------------------');
    this.finalCostService = (this.totalServicios / this.claculo3 );

    this.monthlyServiceLease = (this.insuranceFinal + this.finalCostService);

    // console.log('Monthly financial lease -->',this.financia);
    // console.log('Monthly service lease -->',this.monthlyServiceLease);

    //this.resultado18 = (((this.financia + this.totalServicios)*1.16)+this.ginvestigacion);
    this.resultado18 = (((this.financia + this.monthlyServiceLease)*1.16));
    this.suscripcionInicial18 = ((this.rentaExtra*1.16) + (this.comisionApert*1.16) + this.resultado18 );

     return this.resultado18;
    },

    calcula24(){
      this.precioList = (this.precioLista/1.16);
      this.preciosEspecial = (this.precioaa/1.16);
      this.rentaExtra = (this.preciosEspecial * 0.1);
      this.comisionApert = (this.preciosEspecial * 0.01);
      //console.log('Renta Extra Ordinaria -->',this.rentaExtra);
      //console.log('Comisión Apertura -->',this.comisionApert);
      this.valorResidual = parseFloat(this.residual3)+parseFloat(this.puntos);
      this.valorResidualT = ((this.precioList * this.valorResidual)/100);
      this.restaExtra = (this.preciosEspecial - this.rentaExtra);
      this.calcula = (this.restaExtra-(this.valorResidualT/((1+(this.fix/100)/12)**24)));
      this.calcula2 = ((1-(1+(this.fix/100)/12)**-24));

      this.calcula22 = ((1-(1+(this.fix/100)/12)**-12));

      this.otro = ((this.fix/100)/12);
      this.otro2 = ((1+(this.fix/100)/12));
      //this.claculo3 = ((this.calcula2/this.otro)*this.otro2);
      this.claculo3 = (this.calcula2/this.otro); 

      this.claculo33 = (this.calcula22/this.otro);
      
      this.total = this.calcula/this.claculo3;
      //this.accesories = 9371.64;
      this.accesorios = this.accesories24/this.claculo3;
      this.financia = (this.total+this.accesorios);
      //this.insurance = (((this.precioSeguro/1.16)/12)*(1-this.porcentaje));
      this.insurance = (((this.precioSeguro/1.16))*(1-this.porcentaje));
      this.insuranceFinal = (this.insurance/this.claculo33);
      //this.mantenimiento = (((this.mc24/100)*40000)/24);
      this.mantenimiento = ((this.mc24/100)*40000);
      // this.telematics = 203.49;
      this.telematics = 0;

      this.calcularEdos();

      this.valorPlacas();

      //Plates
      //this.totalPlates = ((this.plates*2)*24);
      this.totalPlates = ((this.plates*24)+2400);

      //Operación Tenencia 
      this.costoTenencia = ((24+12)/12);
      this.tenencia = this.valorEdo*this.costoTenencia;

      //this.totalServicios = (this.insurance + this.valorEdo + this.mantenimiento + this.telematics + this.plates);
      this.totalServicios = (this.totalPlates + this.altaPlacas + this.tenencia + this.mantenimiento + this.ginvestigacion);
      this.finalCostService = (this.totalServicios / this.claculo3 );
      this.monthlyServiceLease = (this.insuranceFinal + this.finalCostService);
      //this.resultado24 = (((this.financia + this.totalServicios)*1.16)+this.ginvestigacion);
      this.resultado24 = (((this.financia + this.monthlyServiceLease)*1.16));
      this.suscripcionInicial24 = ((this.rentaExtra*1.16) + (this.comisionApert*1.16) + this.resultado24 );
      return this.resultado24;
    },

    calcula36(){
      this.precioList = (this.precioLista/1.16);
      this.preciosEspecial = (this.precioaa/1.16);
      this.rentaExtra = (this.preciosEspecial * 0.1);
      this.comisionApert = (this.preciosEspecial * 0.01);
      //console.log('Renta Extra Ordinaria 36 -->',this.rentaExtra);
      //console.log('Comisión Apertura 36 -->',this.comisionApert);
      this.valorResidual = parseFloat(this.residual4)+parseFloat(this.puntos);
      //console.log('Residual --> ',this.valorResidual);
      this.valorResidualT = ((this.precioList * this.valorResidual)/100);
      this.restaExtra = (this.preciosEspecial - this.rentaExtra);
      //console.log('Valor resta renta extraordinaria ---> ',this.restaExtra);
      this.calcula = (this.restaExtra-(this.valorResidualT/((1+(this.fix/100)/12)**36)));
      this.calcula2 = ((1-(1+(this.fix/100)/12)**-36));

      this.calcula22 = ((1-(1+(this.fix/100)/12)**-12));

      this.otro = ((this.fix/100)/12);
      this.otro2 = ((1+(this.fix/100)/12));
      //this.claculo3 = ((this.calcula2/this.otro)*this.otro2); 
      this.claculo3 = (this.calcula2/this.otro);

      this.claculo33 = (this.calcula22/this.otro);

      this.total = this.calcula/this.claculo3;
      //this.accesories = 11796.04;
      this.accesorios = this.accesories36/this.claculo3;
      this.financia = (this.total+this.accesorios);
      //this.insurance = (((this.precioSeguro/1.16)/12)*(1-this.porcentaje));
      this.insurance = (((this.precioSeguro/1.16))*(1-this.porcentaje));
      this.insuranceFinal = (this.insurance/this.claculo33);
      //this.mantenimiento = (((this.mc36/100)*60000)/36);
      this.mantenimiento = (((this.mc36/100)*60000));
      
      // this.telematics = 203.49;
      this.telematics = 0;

      this.calcularEdos();

      this.valorPlacas();

      //Plates
      //this.totalPlates = ((this.plates*2)*36);
      this.totalPlates = ((this.plates*36)+2400);

      //Operación Tenencia 
      this.costoTenencia = ((36+12)/12);
      this.tenencia = this.valorEdo*this.costoTenencia;     
    //  console.log('División 36 / 12',this.costoTenencia);
    //  console.log('Valor del estado -->',this.valorEdo); 

      //this.totalServicios = (this.insurance + this.valorEdo + this.mantenimiento + this.telematics + this.plates);
      this.totalServicios = (this.totalPlates + this.altaPlacas + this.tenencia + this.mantenimiento + this.ginvestigacion);
      //  console.log('Total Plates -->', this.totalPlates);
      //  console.log('Total Alta Placas -->', this.altaPlacas);
      //  console.log('Total Valor Edo -->',this.tenencia);
      //  console.log('Total Mantenimiento -->',this.mantenimiento);
      //  console.log('Total Gastos de Investigación -->',this.ginvestigacion);

      //  console.log('Total Services -->',this.totalServicios);
      //  console.log('------------------------------------');
      this.finalCostService = (this.totalServicios / this.claculo3 );
      this.monthlyServiceLease = (this.insuranceFinal + this.finalCostService);

    //  console.log('Monthly financial lease -->',this.financia);
    //  console.log('Monthly service lease -->',this.monthlyServiceLease);
      //this.resultado36 = (((this.financia + this.totalServicios)*1.16)+this.ginvestigacion);
      this.resultado36 = (((this.financia + this.monthlyServiceLease)*1.16));
      this.suscripcionInicial36 = ((this.rentaExtra*1.16) + (this.comisionApert*1.16) + this.resultado36 );
      return this.resultado36;
    },

    calcula48(){
      this.precioList = (this.precioLista/1.16);
      this.preciosEspecial = (this.precioaa/1.16);
      this.rentaExtra = (this.preciosEspecial * 0.1);
      this.comisionApert = (this.preciosEspecial * 0.01);
      //console.log('Renta Extra Ordinaria 48 -->',this.rentaExtra);
      //console.log('Comisión Apertura 48 -->',this.comisionApert);
      this.valorResidual = parseFloat(this.residual5)+parseFloat(this.puntos);
      //console.log('Residual --> ',this.valorResidual);
      this.valorResidualT = ((this.precioList * this.valorResidual)/100);
      this.restaExtra = (this.preciosEspecial - this.rentaExtra);
      //console.log('Valor resta renta extraordinaria ---> ',this.restaExtra);
      this.calcula = (this.restaExtra-(this.valorResidualT/((1+(this.fix/100)/12)**48)));
      this.calcula2 = ((1-(1+(this.fix/100)/12)**-48));

      this.calcula22 = ((1-(1+(this.fix/100)/12)**-12));

      this.otro = ((this.fix/100)/12);
      this.otro2 = ((1+(this.fix/100)/12));
      //this.claculo3 = ((this.calcula2/this.otro)*this.otro2); 
      this.claculo3 = (this.calcula2/this.otro);

      this.claculo33 = (this.calcula22/this.otro);

      this.total = this.calcula/this.claculo3;
      //this.accesories = 11796.04;
      this.accesorios = this.accesories48/this.claculo3;
      this.financia = (this.total+this.accesorios);
      //this.insurance = (((this.precioSeguro/1.16)/12)*(1-this.porcentaje));
      this.insurance = (((this.precioSeguro/1.16))*(1-this.porcentaje));
      this.insuranceFinal = (this.insurance/this.claculo33);
      //this.mantenimiento = (((this.mc36/100)*60000)/36);
      this.mantenimiento = (((this.mc48/100)*80000));
      
      // this.telematics = 203.49;
      this.telematics = 0;

      this.calcularEdos();

      this.valorPlacas();

      //Plates
      //this.totalPlates = ((this.plates*2)*48);
      this.totalPlates = ((this.plates*48)+2400);

      //Operación Tenencia 
      this.costoTenencia = ((48+12)/12);
      this.tenencia = this.valorEdo*this.costoTenencia;     
      // console.log('División 36 / 12',this.costoTenencia);
      // console.log('Valor del estado -->',this.valorEdo); 

      //this.totalServicios = (this.insurance + this.valorEdo + this.mantenimiento + this.telematics + this.plates);
      this.totalServicios = (this.totalPlates + this.altaPlacas + this.tenencia + this.mantenimiento + this.ginvestigacion);
        // console.log('Total Plates -->', this.totalPlates);
        // console.log('Total Alta Placas -->', this.altaPlacas);
        // console.log('Total Valor Edo -->',this.tenencia);
        // console.log('Total Mantenimiento -->',this.mantenimiento);
        // console.log('Total Gastos de Investigación -->',this.ginvestigacion);

        // console.log('Total Services -->',this.totalServicios);
        // console.log('------------------------------------');
      this.finalCostService = (this.totalServicios / this.claculo3 );
      this.monthlyServiceLease = (this.insuranceFinal + this.finalCostService);

        // console.log('Monthly financial lease -->',this.financia);
        // console.log('Monthly service lease -->',this.monthlyServiceLease);
      //this.resultado36 = (((this.financia + this.totalServicios)*1.16)+this.ginvestigacion);
      this.resultado48 = (((this.financia + this.monthlyServiceLease)*1.16));
      this.suscripcionInicial48 = ((this.rentaExtra*1.16) + (this.comisionApert*1.16) + this.resultado48 );
      return this.resultado48;
    },

    mesesDos(){
      const date = new Date();
      const output = date.getFullYear() + '-' + String(date.getMonth() + 1).padStart(2, '0') + '-' + String(date.getDate()).padStart(2, '0');
      sessionStorage.setItem("fechaVigencia", output);
      sessionStorage.setItem("modalidadNegocio", 4);
      sessionStorage.setItem("valorSuscripcion", this.formatPriceCostos(this.resultado12));
      sessionStorage.setItem("tiempoSuscripcion", '12 Meses');
      sessionStorage.setItem("PlazoSuscripcion", 12);
      this.$router.push({ path: '/formulario'});
    },

    mesesOcho(){
      const date = new Date();
      const output = date.getFullYear() + '-' + String(date.getMonth() + 1).padStart(2, '0') + '-' + String(date.getDate()).padStart(2, '0');
      sessionStorage.setItem("fechaVigencia", output);
      sessionStorage.setItem("modalidadNegocio", 4);
      sessionStorage.setItem("valorSuscripcion", this.formatPriceCostos(this.resultado18));
      sessionStorage.setItem("tiempoSuscripcion", '18 Meses');
      sessionStorage.setItem("PlazoSuscripcion", 18);
      this.$router.push({ path: '/formulario'});
    },

    mesesCuatro(){
      const date = new Date();
      const output = date.getFullYear() + '-' + String(date.getMonth() + 1).padStart(2, '0') + '-' + String(date.getDate()).padStart(2, '0');
      sessionStorage.setItem("fechaVigencia", output);
      sessionStorage.setItem("modalidadNegocio", 4);
      sessionStorage.setItem("valorSuscripcion", this.formatPriceCostos(this.resultado24));
      sessionStorage.setItem("tiempoSuscripcion", '24 Meses');
      sessionStorage.setItem("PlazoSuscripcion", 24);
      this.$router.push({ path: '/formulario'});
    },

    mesesSeis(){
      const date = new Date();
      const output = date.getFullYear() + '-' + String(date.getMonth() + 1).padStart(2, '0') + '-' + String(date.getDate()).padStart(2, '0');
      sessionStorage.setItem("fechaVigencia", output);
      sessionStorage.setItem("modalidadNegocio", 4);
      sessionStorage.setItem("valorSuscripcion", this.formatPriceCostos(this.resultado36));
      sessionStorage.setItem("tiempoSuscripcion", '36 Meses');
      sessionStorage.setItem("PlazoSuscripcion", 36);
      this.$router.push({ path: '/formulario'});
    },

    mesesCuatroOcho(){
      const date = new Date();
      const output = date.getFullYear() + '-' + String(date.getMonth() + 1).padStart(2, '0') + '-' + String(date.getDate()).padStart(2, '0');
      sessionStorage.setItem("fechaVigencia", output);
      sessionStorage.setItem("modalidadNegocio", 4);
      sessionStorage.setItem("valorSuscripcion", this.formatPriceCostos(this.resultado36));
      sessionStorage.setItem("tiempoSuscripcion", '48 Meses');
      sessionStorage.setItem("PlazoSuscripcion", 48);
      this.$router.push({ path: '/formulario'});
    },

    calcularEdos(){
     if(this.estado == 'DF'){

      this.valorEdo = (((3/100)*this.precioLista));
      sessionStorage.setItem("emplacamiento", 'CDMX / Edo. de Mex');
      sessionStorage.setItem("idemplacamiento", 'DF');

      //  if( this.precioLista < 686791.46){
          //this.valorEdo = (((1/100)*this.precioaa)/12);
          // this.valorEdo = (((1/100)*this.precioLista));
          // sessionStorage.setItem("emplacamiento", 'CDMX / Edo. de Mex');
          // sessionStorage.setItem("idemplacamiento", 'DF');
          //console.log('Valor Estado (-) -->',this.valorEdo);
      //  } else {
          //this.valorEdo = (((8.7/100)*this.precioaa)/12);
          // this.valorEdo = (((8.7/100)*this.precioLista));
          // sessionStorage.setItem("emplacamiento", 'CDMX / Edo. de Mex');
          // sessionStorage.setItem("idemplacamiento", 'DF');
          //console.log('Valor Estado (+) -->',this.valorEdo);
      //  }
     } else if(this.estado == 'QT'){
       if( this.precioLista < 476104.33){
          //this.valorEdo = (((3.75/100)*this.precioaa)/12);
          this.valorEdo = (((3.75/100)*this.precioLista));
          sessionStorage.setItem("emplacamiento", 'Querétaro');
          sessionStorage.setItem("idemplacamiento", 'QT');
       } else {
          this.valorEdo = (((10.875/100)*this.precioLista));
          sessionStorage.setItem("emplacamiento", 'Querétaro');
          sessionStorage.setItem("idemplacamiento", 'QT');
       }
     } else if(this.estado == 'MN'){
       if( this.precioLista < 428768.31){
        //this.valorEdo = (((3/100)*this.precioaa)/12);        
          this.valorEdo = (((3/100)*this.precioLista));
          sessionStorage.setItem("emplacamiento", 'Michoacán');
          sessionStorage.setItem("idemplacamiento", 'MN');
       } else {
          this.valorEdo = (((8.7/100)*this.precioLista));
          sessionStorage.setItem("emplacamiento", 'Michoacán');
          sessionStorage.setItem("idemplacamiento", 'MN');
       }
     } else if(this.estado == 'GT'){
       if( this.precioLista < 580000){
        //this.valorEdo = (((1/100)*this.precioaa)/12);
          this.valorEdo = (((1/100)*this.precioLista));
          sessionStorage.setItem("emplacamiento", 'Guanajuato');
          sessionStorage.setItem("idemplacamiento", 'GT');
       } else {
          this.valorEdo = (((3/100)*this.precioLista));
          sessionStorage.setItem("emplacamiento", 'Guanajuato');
          sessionStorage.setItem("idemplacamiento", 'GT');
       }
     }
    },

    formatPrice(value) {
        let val = (value/1).toFixed(0).replace('.', '.')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    },

    formatPriceCostos(value) {
        let val = (value/1).toFixed(2).replace('.', '.')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    },
  },

  created() {
    this.cargarInfoVehiculo();
   },

}
</script>

<style scoped>


</style>